import { atomicStylePropsConverterMap } from './atomics/atomicPropsToCss'
import { fontConverterMap } from './compositions/Font/fontPropsToCss'
import type { Spx } from '@wix/thunderbolt-becky-types'
import { mathConverterMap } from './compositions/MathFunction/mathPropsToCss'
import { colorConverterMap } from './compositions/Color/colorPropsToCss'
import { StylePropItem } from '@wix/thunderbolt-becky-root'
import _ from 'lodash'

type Style = {
	id: string
	type: string
	style: { properties: { [prop: string]: StylePropItem } }
}

const stylePropsToCssConverterMap = _.mergeWith(
	{
		...atomicStylePropsConverterMap,
	},
	{ ...fontConverterMap },
	{ ...mathConverterMap },
	{ ...colorConverterMap }
) as Record<string, (styleProp: StylePropItem, spx: Spx) => Record<string, string> | string>

const convertStyleProp = (styleProp: StylePropItem, propName: string, spx: Spx): Record<string, string> => {
	const cssProps = stylePropsToCssConverterMap[styleProp.type](styleProp, spx)

	if (typeof cssProps === 'string') {
		return { [`--${propName}`]: cssProps }
	}

	const cssVars: Record<string, string> = {}
	Object.entries(cssProps).forEach(([key, subpropValue]) => {
		if (key === styleProp.type) {
			cssVars[`--${propName}`] = subpropValue
		} else {
			cssVars[`--${propName}-${key}`] = subpropValue
		}
	})

	return cssVars
}

export const stylePropsToCssVars = (style: any): Record<string, string | number> => {
	const styleProps = (style as Style).style.properties || (style as Style).style

	const { spx } = style
	const cssVars = _.reduce(
		styleProps,
		(acc: Record<string, string | number>, styleProp, propName) => {
			const converterVars = convertStyleProp(styleProp, propName, spx)
			Object.assign(acc, converterVars)
			return acc
		},
		{}
	)

	return cssVars
}
